import {
  GET_LIST_SALES_TYPE,
  CREATE_SALES_TYPE_SINGLE_OUTLET,
  CREATE_SALES_TYPE_ALL_OUTLET,
  GET_DETAIL_SALES_TYPE,
  UPDATE_SALES_TYPE,
  DELETE_SALES_TYPE,
  UPDATE_STATUS_SALES_TYPE
} from './constants'
import {
  serviceLibraryErrorCallback,
  serviceLibrarySuccessCallback
} from '../../callbacks'

export function getSalesType (params) {
  return axios
    .get(GET_LIST_SALES_TYPE, {params, withCredentials: true})
    .then(serviceLibrarySuccessCallback)
    .catch(serviceLibraryErrorCallback)
}

export function getSalesTypeDetail (salestypeId) {
  return axios
    .get(GET_DETAIL_SALES_TYPE(salestypeId), {withCredentials: true})
    .then(serviceLibrarySuccessCallback)
    .catch(serviceLibraryErrorCallback)
}

export function deleteSalesType (id) {
  return axios
    .delete(DELETE_SALES_TYPE(id), {withCredentials: true})
    .then(serviceLibrarySuccessCallback)
    .catch(serviceLibraryErrorCallback)
}

export function activatedSalesType (id, body) {
  return axios
    .put(UPDATE_STATUS_SALES_TYPE(id), body, {withCredentials: true})
    .then(serviceLibrarySuccessCallback)
    .catch(serviceLibraryErrorCallback)
}

export function createSalesType (data) {
  return axios
    .post(CREATE_SALES_TYPE_SINGLE_OUTLET, data, {withCredentials: true})
    .then(serviceLibrarySuccessCallback)
    .catch(serviceLibraryErrorCallback)
}

export function updateSalesType (idSalesType, data) {
  return axios
    .put(UPDATE_SALES_TYPE(idSalesType), data, {withCredentials: true})
    .then(serviceLibrarySuccessCallback)
    .catch(serviceLibraryErrorCallback)
}

export function createSalesTypeAllOutlets (bodyData) {
  return axios
    .post(CREATE_SALES_TYPE_ALL_OUTLET, bodyData, {withCredentials: true})
    .then(serviceLibrarySuccessCallback)
    .catch(serviceLibraryErrorCallback)
}



// WEBPACK FOOTER //
// ./app/api/libraries/salesType/salesType.js